import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconIssues(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        fill="currentColor"
        d="M2 9V6c0-.55.196-1.02.587-1.412A1.926 1.926 0 0 1 4 4h16c.55 0 1.02.196 1.413.588.391.391.587.862.587 1.412v3h-2V6H4v3H2Zm2 11c-.55 0-1.02-.196-1.413-.587A1.926 1.926 0 0 1 2 18v-3h2v3h16v-3h2v3c0 .55-.196 1.02-.587 1.413A1.926 1.926 0 0 1 20 20H4Zm6-3c.183 0 .358-.046.525-.137a.863.863 0 0 0 .375-.413l3.1-6.2 1.1 2.2c.083.183.208.32.375.413.167.091.342.137.525.137h5c.283 0 .52-.096.712-.287A.968.968 0 0 0 22 12a.968.968 0 0 0-.288-.713A.968.968 0 0 0 21 11h-4.375L14.9 7.55a.741.741 0 0 0-.375-.388A1.265 1.265 0 0 0 14 7.05c-.183 0-.358.038-.525.112a.741.741 0 0 0-.375.388l-3.1 6.2-1.1-2.2a.863.863 0 0 0-.375-.413A1.074 1.074 0 0 0 8 11H3a.967.967 0 0 0-.712.287A.968.968 0 0 0 2 12c0 .283.096.52.288.713.191.191.429.287.712.287h4.375L9.1 16.45c.083.183.208.32.375.413.167.091.342.137.525.137Z"
      />
    </BaseIcon>
  );
}
